import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';

import { TextInput } from '../Forms';

//
// NOTE: This component is tailored to a very specific usecase and not a generic one.
//       It should be refactored to be more generic and not specific to a list of sites.
//
const ListFilter = ({ siteList }) => {
  const [filteredList, setFilteredList] = useState(siteList);

  const filterSiteList = (filterValue) => {
    return siteList.filter((site) =>
      site.name.toLowerCase().includes(filterValue.toLowerCase()),
    );
  };

  const handleChange = (e) => {
    const list = filterSiteList(e.target.value);
    setFilteredList(list);
  };

  return (
    <Fragment>
      <TextInput
        aria-label="Filter sites"
        data-testid="list-filter"
        field="list-filter"
        onChange={handleChange}
        placeholder="Filter sites"
      />
      <ul className="pl-0 list-none">
        {filteredList.length > 0 ? (
          filteredList.map((site) => (
            <li key={site.id}>
              <a href={`/sites/${site.id}`}>{site.name}</a>
            </li>
          ))
        ) : (
          <li>No Result Found</li>
        )}
      </ul>
    </Fragment>
  );
};

ListFilter.propTypes = {
  siteList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ListFilter;
